import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import { useMatch } from 'react-router';
import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import useLiveContext from '../../../../LiveContext/useLiveContext';
import { useListLiveProjectsQuery } from '../../../../../generated/core-api/graphql-react-query';
import StyledButton from './styles';
import SelectProjectMenu from './Components/SelectProjectMenu';

function useProjectId(): string | null {
  const { projectId } = useLiveContext();
  const cardPathMatch = useMatch('/projects/:projectId/cards/:cardId');
  const decisionTreePathMatch = useMatch('/projects/:projectId/decision-trees/:decisionTreeId');

  if (cardPathMatch?.params.projectId) {
    return cardPathMatch.params.projectId;
  }

  if (decisionTreePathMatch?.params.projectId) {
    return decisionTreePathMatch.params.projectId;
  }

  return projectId;
}

export default function ProjectButton() {
  const projectId = useProjectId();
  const projects = useListLiveProjectsQuery({});
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { t } = useTranslation();

  const current = React.useMemo(
    () => projects.data?.listProjects.find((p) => p.id === projectId) ?? { name: t('header.title') },
    [projectId, projects.data],
  );

  if (!projects.data && projects.isLoading) {
    return <div />;
  }

  return (
    <>
      <StyledButton
        className={clsx('project', { active: !!anchorEl })}
        onClick={(e) => { setAnchorEl((prev) => (prev ? null : e.currentTarget)); }}
      >
        <div title={current.name}>
          {current.name}
        </div>
        <ArrowDropDownIcon />
      </StyledButton>
      <SelectProjectMenu anchorEl={anchorEl} onClose={() => { setAnchorEl(null); }} options={projects.data?.listProjects} current={projectId} />
    </>
  );
}
